import { RootContextBase } from "@skylab-shared/core";
import { UserPermissionKind } from "@skylab-shared/dataModel";
import { Singleton } from "@skylab-shared/utils";
import { LoggedUserQuery } from "../user/queries/logged-user.query-base";
import { AvailabilityService, availabilityCheckerFactory } from "./availability";

@Singleton
class PermissionAvailabilityBase extends AvailabilityService<UserPermissionKind> {
	private permissions: UserPermissionKind[];

	protected async onRegisterAsync(
		rootContext: RootContextBase
	): Promise<void> {
		const loggedUser = rootContext.getPreloaded(LoggedUserQuery);
		this.permissions = loggedUser?.permission || [];
	}

	protected onCheck(permissions: UserPermissionKind | UserPermissionKind[]): boolean {
		if (Array.isArray(permissions)) {
			return permissions.reduce((pV, cV) => pV && this.permissions.includes(cV), true);
		} else {
			return !!this.permissions.includes(permissions);
		}
	};
};

export const PermissionAvailability = new PermissionAvailabilityBase();
export const withPermission = availabilityCheckerFactory(PermissionAvailability);
